<template>
  <div class="deals-block">
    <slot name="header" :filterChange="filterChange" />
    <div ref="containerRef" class="deals-container__cta-wrapper">
      <div
        v-if="!isMobile || isRouteplanner"
        ref="gridRef"
        :class="{ 'desktop-col-4': !isRouteplanner }"
      >
        <slot name="content" :setDestinationData="setDestinationData" />
      </div>

      <div v-if="isMobile" ref="carouselRef" class="splide">
        <div class="splide__track">
          <ul class="splide__list"></ul>
        </div>
      </div>
    </div>
  </div>
  <slot
    name="dealsmodal"
    :destinationData="destinationData"
    :destinationModalOpen="destinationModalOpen"
    :closeDestinationModal="closeDestinationModal"
    :closeVisaModal="closeVisaModal"
    :closeBothModals="closeBothModals"
    :openVisaModal="openVisaModal"
  />
  <slot
    name="visamodal"
    :destinationData="destinationData"
    :destinationModalOpen="destinationModalOpen"
    :openDestinationModal="openDestinationModal"
    :closeDestinationModal="closeDestinationModal"
    :closeVisaModal="closeVisaModal"
    :closeBothModals="closeBothModals"
  />
</template>
<script setup>
import { ref, provide, onMounted, watch, defineProps } from 'vue';
import { useIsMobile } from '../../hooks/useIsMobile';
import Splide from '@splidejs/splide';

const getRandomNumber = () => {
  return Math.floor(Math.random() * 1000);
};

const filterRef = ref('');
const containerRef = ref(null);
const carouselRef = ref(null);
const destinationData = ref({});
const destinationModalOpen = ref(false);
const visaModalOpen = ref(false);
const buttonsList = ref([]);
const gridRef = ref(false);

provide('injectedIsOpenDeals', destinationModalOpen);
provide('injectedIsOpenVisa', visaModalOpen);

const isMobile = useIsMobile();
const props = defineProps({
  isRouteplanner: {
    type: Boolean,
    default: false,
  },
});
const filterChange = (a) => {
  filterRef.value = a.value;
  filterChildrenHandler();
};

const filterChildrenHandler = () => {
  const children = Array.from(
    containerRef.value?.querySelectorAll('[data-tags]'),
  );
  if (!filterRef.value) {
    children.forEach((element) => {
      element.style.display = 'flex';
    });
  } else {
    const filteredChildren = Array.from(
      containerRef.value?.querySelectorAll(`[data-tags~="${filterRef.value}"]`),
    );
    const nonMatchingChildren = children.filter(
      (child) => !filteredChildren.includes(child),
    );
    nonMatchingChildren.forEach((element) => {
      element.style.display = 'none';
    });

    filteredChildren.slice(0, 8).forEach((element) => {
      element.style.display = 'flex';
    });
  }

  if (carouselRef.value) {
    carouselMountHandler();
  }
};

const setDestinationData = (data) => {
  destinationData.value = { ...data };
  openDestinationModal();
  visaModalOpen.value = false;
};

const openDestinationModal = () => {
  destinationModalOpen.value = true;
};
const closeDestinationModal = () => {
  destinationModalOpen.value = false;
};

const openVisaModal = () => {
  destinationModalOpen.value = false;
  visaModalOpen.value = true;
};

const closeVisaModal = () => {
  visaModalOpen.value = false;
};

const closeBothModals = () => {
  destinationModalOpen.value = false;
  visaModalOpen.value = false;
};

const carouselMountHandler = () => {
  const container = carouselRef.value;
  if (container.splide) {
    container.splide.destroy();
  }
  const list = container.querySelector('.splide__list');
  list.innerHTML = '';

  const children = Array.from(buttonsList.value);
  const filteredChildren = children.filter(
    (child) => child.getAttribute('data-tags') === filterRef.value,
  );

  for (let i = 0; i < filteredChildren.length; i += 3) {
    const group = document.createElement('li');
    group.classList.add('splide__slide');

    for (let j = i; j < i + 3 && j < filteredChildren.length; j++) {
      const child = filteredChildren[j];
      group.appendChild(child);
    }

    list.appendChild(group);
  }

  const splide = new Splide(container, {
    arrows: false,
    perPage: 1,
    perMove: 1,
    splideId: getRandomNumber(),
  }).mount();

  container.splide = splide;
};

onMounted(() => {
  const buttons = containerRef.value?.querySelectorAll('[data-tags]');
  buttonsList.value = buttons;
});

watch(carouselRef, () => {
  if (isMobile.value === true) {
    carouselMountHandler();
  }
});

watch(gridRef, () => {
  filterChildrenHandler();
});
</script>
